import { useEffect, useRef } from 'react';

/**
 * Custom hook to add a listener on the global `document` object and removes the listener on component unmount.
 *
 * eventName can be changed and old listeners will be cleaned up and new ones added
 *
 * @param {String} eventName The name of the event to listen to
 * @param {Function} callback The function to invoke for `eventName`
 */
export default function useDocumentEvent(eventName, callback) {
    const callbackRef = useRef();
    callbackRef.current = callback;

    useEffect(() => {
        function handler(e) {
            if (typeof callbackRef.current === 'function') callbackRef.current(e);
        }

        document.addEventListener(eventName, handler);

        return () => document.removeEventListener(eventName, handler);
    }, [eventName]);
}
